import * as components from './components'
import * as actions from './actions'
import * as types from './actionTypes'
import * as containers from './containers'
import reducer from './reducer'

export default {
  actions,
  types,
  reducer,
  containers,
  components,
}



// WEBPACK FOOTER //
// ./src/features/Cart/index.js